/**
 * session-ready is a one-shot per userId. Do not fire it while owner
 * onboarding is still open: the coordinator skips the catalog pull
 * (`canRunOperationalBackgroundWork() === false`) and the one-shot is
 * consumed, so Home stays on the day-1 skeleton until F5 / alt-tab.
 */
export function shouldAttemptSessionReadyPull(input: {
  hasUserId: boolean;
  operationalReady: boolean;
  alreadyAttempted: boolean;
}): boolean {
  return input.hasUserId && input.operationalReady && !input.alreadyAttempted;
}
